import { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  FloatingLabel,
  Form,
  Modal,
  Row,
} from "react-bootstrap";
import Feedback from "react-bootstrap/esm/Feedback";
import { useTranslation } from "react-i18next";
import { ValidateToken } from "../../../helpers/validateToken";
import { startLogout } from "../../../store/auth";
import { toast } from "react-toastify";
import { LogoPetroprix } from "../../ui/LogoPetroprix";
import axiosApi from "../../../axios/axios-api";
import { MiniLoader } from "../../ui/MiniLoader";
import { useDispatch, useSelector } from "react-redux";

const URL_POST_CREATE_MASSIVE = "flotas/crearVehiculosMasiva";

export function ModalAddRestrictions(props) {
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const { token, flotaActiva } = useSelector((state) => state.auth);
  const list = useSelector((state) => state.vehicles.vehicles[0]);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  let restrictions = {};

  useEffect(() => {
    setValidated(false);
  }, []);

  const validate = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    setValidated(false);

    // Recogemos los datos del formulario
    let max_operacion = document.getElementById(
      "flotas-modal-editar-form-impMaxRepost"
    );
    let max_imp_red = document.getElementById(
      "flotas-modal-editar-form-impMaxRepostPetroprix"
    );
    let max_imp_gas = document.getElementById(
      "flotas-modal-editar-form-impMaxDiaGas"
    );
    let max_op_red = document.getElementById(
      "flotas-modal-editar-form-numRepostDiaPetroprix"
    );
    let max_op_gas = document.getElementById(
      "flotas-modal-editar-form-numRepostDiaGas"
    );
    let max_op_30 = document.getElementById(
      "flotas-modal-editar-form-numRepostDia30Min"
    );

    let dataValid = {
      impMaxRepost: false,
      impMaxRepostPetroprix: false,
      impMaxDiaGas: false,
      numRepostDiaPetroprix: false,
      numRepostDiaGas: false,
      numRepostDia30Min: false,
    };

    if (max_operacion.value === "") {
      max_operacion.setCustomValidity(" ");
      dataValid.impMaxRepost = false;
    } else {
      max_operacion.setCustomValidity("");
      dataValid.impMaxRepost = true;
    }

    if (max_imp_red.value === "") {
      max_imp_red.setCustomValidity(" ");
      dataValid.impMaxRepostPetroprix = false;
    } else {
      max_imp_red.setCustomValidity("");
      dataValid.impMaxRepostPetroprix = true;
    }

    if (max_imp_gas.value === "") {
      max_imp_gas.setCustomValidity(" ");
      dataValid.impMaxDiaGas = false;
    } else {
      max_imp_gas.setCustomValidity("");
      dataValid.impMaxDiaGas = true;
    }

    if (max_op_red.value === "") {
      max_op_red.setCustomValidity(" ");
      dataValid.numRepostDiaPetroprix = false;
    } else {
      max_op_red.setCustomValidity("");
      dataValid.numRepostDiaPetroprix = true;
    }

    if (max_op_gas.value === "") {
      max_op_gas.setCustomValidity(" ");
      dataValid.numRepostDiaGas = false;
    } else {
      max_op_gas.setCustomValidity("");
      dataValid.numRepostDiaGas = true;
    }

    if (max_op_30.value === "") {
      max_op_30.setCustomValidity(" ");
      dataValid.numRepostDia30Min = false;
    } else {
      max_op_30.setCustomValidity("");
      dataValid.numRepostDia30Min = true;
    }

    if (
      !dataValid.impMaxRepost ||
      !dataValid.impMaxRepostPetroprix ||
      !dataValid.impMaxDiaGas ||
      !dataValid.numRepostDiaPetroprix ||
      !dataValid.numRepostDiaGas ||
      !dataValid.numRepostDia30Min
    ) {
      setValidated(true);
      return;
    } else {
      setValidated(true);

      restrictions = {
        max_operacion: max_operacion.value,
        max_imp_red: max_imp_red.value,
        max_imp_gas: max_imp_gas.value,
        max_op_red: max_op_red.value,
        max_op_gas: max_op_gas.value,
        max_op_30: max_op_30.value,
      };
      addVehiculos();
    }
  };

  const addVehiculos = async () => {
    try {
      setLoading(true);
      if (process.env.REACT_APP_URL_API && ValidateToken()) {
        let values = [];
        let vehicleType = 0;
        values = list.map((e) => {
          if (e.tipo_vehiculo === "Turismo") {
            vehicleType = 0;
          } else if (e.tipo_vehiculo === "Motocicleta") {
            vehicleType = 1;
          }
          if (e.tipo_vehiculo === "Camión") {
            vehicleType = 2;
          }
          return { ...e, ["tipo_vehiculo"]: vehicleType };
        });

        const data = {
          idCcp: flotaActiva?.id_cuenta ?? "",
          vehiculos: values,
          ...restrictions,
        };

        const response = await axiosApi.post(URL_POST_CREATE_MASSIVE, data, {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
        });
        if (response?.data?.code === 201 || response?.data?.code === 206) {
          props.onHide(true, response?.data?.code, response?.data?.message);
        } else {
          toast(response.data.message, {
            icon: <LogoPetroprix />,
          });
        }
        setLoading(false);
      } else {
        dispatch(startLogout("expired"));
      }
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title>{t("flotas.modal-restricciones-vehiculos")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Container>
          <Form
            noValidate
            validated={validated}
            autoComplete="off"
            onSubmit={(e) => validate(e)}
          >
            {/* Importes maximos y nº repostajes diarios */}
            <Row className="mt-4">
              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t("flotas.modal.editar.form.imp-max-repost")}
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    id="flotas-modal-editar-form-impMaxRepost"
                    placeholder={t("flotas.modal.editar.form.imp-max-repost")}
                    defaultValue={150}
                  />
                  <Feedback type="invalid">
                    {t(
                      "flotas.modal.editar.form.validation.imp-max-repost.invalid"
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>
              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t("flotas.modal.editar.form.num-repost-dia-petroprix")}
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    id="flotas-modal-editar-form-numRepostDiaPetroprix"
                    placeholder={t(
                      "flotas.modal.editar.form.num-repost-dia-petroprix"
                    )}
                    defaultValue={3}
                  />
                  <Feedback type="invalid">
                    {t(
                      "flotas.modal.editar.form.validation.num-repost-dia-petroprix.invalid"
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>

              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t("flotas.modal.editar.form.imp-max-repost-petroprix")}
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    id="flotas-modal-editar-form-impMaxRepostPetroprix"
                    placeholder={t(
                      "flotas.modal.editar.form.imp-max-repost-petroprix"
                    )}
                    defaultValue={150}
                  />
                  <Feedback type="invalid">
                    {t(
                      "flotas.modal.editar.form.validation.imp-max-repost-petroprix.invalid"
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>

              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t("flotas.modal.editar.form.num-repost-dia-gas")}
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    id="flotas-modal-editar-form-numRepostDiaGas"
                    placeholder={t(
                      "flotas.modal.editar.form.num-repost-dia-gas"
                    )}
                    defaultValue={3}
                  />
                  <Feedback type="invalid">
                    {t(
                      "flotas.modal.editar.form.validation.num-repost-dia-gas.invalid"
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>

              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t("flotas.modal.editar.form.imp-max-dia-gas")}
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    id="flotas-modal-editar-form-impMaxDiaGas"
                    placeholder={t("flotas.modal.editar.form.imp-max-dia-gas")}
                    defaultValue={150}
                  />
                  <Feedback type="invalid">
                    {t(
                      "flotas.modal.editar.form.validation.imp-max-dia-gas.invalid"
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>

              <Col sm={12} lg={6}>
                <FloatingLabel
                  label={t("flotas.modal.editar.form.num-repost-dia-30min")}
                  className="mb-3"
                >
                  <Form.Control
                    type="text"
                    id="flotas-modal-editar-form-numRepostDia30Min"
                    placeholder={t(
                      "flotas.modal.editar.form.num-repost-dia-30min"
                    )}
                    defaultValue={3}
                  />
                  <Feedback type="invalid">
                    {t(
                      "flotas.modal.editar.form.validation.num-repost-dia-30min.invalid"
                    )}
                  </Feedback>
                </FloatingLabel>
              </Col>
            </Row>
          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Row>
          <div className="d-flex gap-2 mt-2 justify-content-end align-items-center">
            <Button
              variant="outline-primary"
              size="md"
              onClick={() => {
                props.onHide();
              }}
            >
              {t("flotas.modal.editar.form.btn-cancel")}
            </Button>
            <Button
              variant="primary"
              size="md"
              type="submit"
              onClick={(e) => validate(e)}
            >
              {loading ? (
                <MiniLoader />
              ) : (
                t("flotas.modal.editar.form.btn-guardar")
              )}
            </Button>
          </div>
        </Row>
      </Modal.Footer>
    </Modal>
  );
}
